import LazyLoad from "vanilla-lazyload"

export const lazyLoading = new LazyLoad({
  elements_selector: "[data-src], [data-bg]",
})

document.addEventListener("lazyloadReinit", () => {
  lazyLoading.update()
})
